import styled from "styled-components"

const InforContainerDiv = styled.ul`
  background-color: #30a7d7;
  border-radius: 0.5rem;
  color: #ffff;
  display: grid;
  font-size: 1.0625rem;
  grid-template-columns: 2fr 2fr;
  height: 16rem;
  padding: 20px 0 0 30px;
  width: 28rem;
`

export default InforContainerDiv
